import Vue from 'vue';
import ScheduledRespondentForm from '@/components/pages/RespondentsWizardPage/forms/scheduledRespondentForm';
import UnscheduledRespondentForm from '@/components/pages/RespondentsWizardPage/forms/unscheduledRespondentForm';
import RecordRespondentForm from '@/components/pages/RespondentsWizardPage/forms/recordRespondentForm';
import ConfirmationPage from '@/components/pages/RespondentsWizardPage/confirmation';

Vue.component('scheduled-respondent-form', ScheduledRespondentForm);
Vue.component('unscheduled-respondent-form', UnscheduledRespondentForm);
Vue.component('record-respondent-form', RecordRespondentForm);
Vue.component('confirmation-page', ConfirmationPage);
